import { configurationSettings } from '@vista-digital/occ-domain';
import { createContext } from 'react';
import { OccI18N } from '../../../utils/i18n';
import { defaultOccContextProps } from './props';
const { displayText: { cinemaChainName }, config: { locale } } = defaultOccContextProps;
export const OccContextInstance = createContext(Object.assign(Object.assign({}, defaultOccContextProps), { i18n: new OccI18N(undefined, cinemaChainName, locale, configurationSettings.data.order.taxMode) }));
//# sourceMappingURL=context.js.map